/**
 * Список договоров на осуществление образовательной деятельности
 */
import { Pagination } from '@n3/ng-api-common';
import { EducationContractShort } from './educationContractShort.model';
export class EducationContractList extends Pagination {
    public _isEmpty: boolean; /*указывает на то пустой ли объект*/
    public items: EducationContractShort[]; /**/

    constructor(json?: any) {
        if (json === void 0 || json === null) {
            json = {};
        }
        super(json);

        this.items = [];
        if (json.items) {
          for (const i in json.items) {
            if ( json.items.hasOwnProperty( i ) ) {
                this.items.push(new EducationContractShort(json.items[i]));
            }
          }
        }
        this._isEmpty = this.isEmpty(this);
    }
}
